import axios from "axios";
import AlertStore from '@/stores/AlertStore'

import {ENDPOINT_MARCHES, ENDPOINT_SEARCH, ENDPOINT_EXPORT, ENDPOINT_IMPORT} from '@/constants/endpoints'

let store = {
  debug: true,

  get(id) {
    return axios
        .get(ENDPOINT_MARCHES + '/' + id)
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  getAll() {
    return axios
        .get(ENDPOINT_MARCHES)
        .then(value => value.data)
        .catch(error => AlertStore.pushError(error.response.data.message));
  },

  create(marche) {
    return axios
        .post(ENDPOINT_MARCHES, marche)
        .then(() => {
          AlertStore.pushSuccess('Marché créé avec succès.');
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  update(marche) {
    return axios
        .put(ENDPOINT_MARCHES, marche)
        .then(() => {
          AlertStore.pushSuccess('Marché modifié avec succès.');
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },
  delete(id) {
    return axios
        .delete(ENDPOINT_MARCHES + '/' + id)
        .then(() => {
          AlertStore.pushSuccess('Marché supprimé avec succès.');
        })
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  search(marche, statut, pageIndex, pageSize, sortOptions) {
    let recherche = [];
    recherche.push({key: 'reference', operation: ':', value: marche.reference});
    recherche.push({key: 'ligne', operation: '=', value: marche.ligne});
    recherche.push({key: 'typeMarche', operation: '=', value: marche.typeMarche});
    recherche.push({key: 'groupement', operation: ':', value: marche.groupement});
    recherche.push({key: 'libelleCourt', operation: ':', value: marche.libelleCourt});
    recherche.push({key: 'libelleLong', operation: ':', value: marche.libelleLong});
    recherche.push({key: 'titulaire', operation: ':', value: marche.titulaire});
    recherche.push({key: 'secteurGeographique', operation: '=', value: marche.secteurGeographique});
    recherche.push({key: 'territoire', operation: '=', value: marche.territoire});
    recherche.push({key: 'termine', operation: '=', value: marche.termine});

    switch (statut) {
      case 'en cours':
        recherche.push({key: 'dateDebut', operation: '<', value: new Date().toISOString()});
        recherche.push({key: 'dateFin', operation: '>', value: new Date().toISOString()});
        break;
      case 'termine':
        recherche.push({key: 'dateFin', operation: '<', value: new Date().toISOString()});
        break;
      case 'a venir':
        recherche.push({key: 'dateDebut', operation: '>', value: new Date().toISOString()});
        break;
      default:
        break;
    }

    let url = `${ENDPOINT_MARCHES + ENDPOINT_SEARCH}?page=${pageIndex}&size=${pageSize}`;
    if (sortOptions) {
      for (const sortOption of sortOptions) {
        url += `&sort=${sortOption.sortBy},${sortOption.sortDirection}`;
      }
    }

    return axios
        .post(url, recherche);
  },

  getByEntrepriseIdAndValideEmpreinte(entrepriseId) {
    return axios
        .get(ENDPOINT_MARCHES + '/entreprise/' + entrepriseId)
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  onMarcheSearch(marche, isId, marcheIds) {
    if (isId) {
      return marche ? marcheIds.filter(x => x.id === marche) : marcheIds
    }
    return marche ? marcheIds.filter(x => x.text.toLowerCase().includes(marche.toLowerCase())) : marcheIds
  },

  export() {
    return axios.get(`${ENDPOINT_MARCHES + ENDPOINT_EXPORT}`);
  },

  import(file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(ENDPOINT_MARCHES + ENDPOINT_IMPORT, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  countMarcheTerritoireIndetermine() {
    return axios
        .get(ENDPOINT_MARCHES + '/territoire/indetermine')
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

  getMarcheByDirPreId(dirPreId) {
    return axios
        .get(ENDPOINT_MARCHES + '/directions-prescriptrices-principales/' + dirPreId)
        .then(response => response.data)
        .catch(error => {
          AlertStore.pushError(error.response.data.message);
        })
  },

};

export default store;
